import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Filter = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Filter' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='3 6 10 13 10 21 14 21 14 13 21 6 21 3 3 3' />
  </StyledIcon>
);
